/*
* This component takes in 4 parameters (frist name, last name, showfullname, and fullname), only showfullname is required
* When showfullname is true, full name is needed to display the full name.
* Otherwise, it'll show either the first letter of first name, or first letter of last name, or the initial
* i.e. if firstName='Kevin', it'll show K. lastname='Hart', it'll show H. Pass both first and last name, it'll show KH.
* if showfullname = true and full name = 'Kevin Hart', it'll show KH Kevin Hart.
*/

import React, {PropTypes, Component} from 'react'
import Tooltip from 'react-tooltip';
import uniqid from 'uniqid';

import './style.scss'

class NameCircle extends Component{

  static propTypes = {
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    showFullName: PropTypes.bool.isRequired,
    fullName: PropTypes.string,
  }

  render(){
    const {firstName, lastName, showFullName, fullName, style} = this.props;

    let initial;
    if(firstName && lastName){
      initial = firstName[0].toUpperCase() + lastName[0].toUpperCase()
    } else if (firstName && !lastName) {
      initial = firstName[0].toUpperCase()
    } else if (!firstName && lastName){
      initial = lastName[0].toUpperCase()
    } else if (!firstName && !lastName && fullName){
      initial = fullName[0].toUpperCase()
    }

    let initialColor = `name-bubble color${initial[0]}`;

    const id = 'teacher-name-' + uniqid();

    return(
      <div className='name-circle-container' style={style} data-tip data-for={id}>
        <span className={initialColor}>{initial}</span>
        {showFullName && <span className='full-name-text'>{fullName}</span>}
        <Tooltip
          id={id}
          effect='solid'
          place='bottom'
          type='info'
          getContent={()=> { return fullName ? fullName : firstName; }}
        />
      </div>
    )

  }
}

export default NameCircle;



// WEBPACK FOOTER //
// ./src/components/UI/NameCircle/index.js